import React from 'react'

import FormSelect from '@f/elements/FormSelect'

const FilterSelect = props => {
  const handleSelect = event => {
    const target = event.target

    if (props.isVendorDirect) {
      window.location.pathname = props.filter.values.find(
        el => el.id == target.value
      ).url
    } else {
      const param = `${target.name}__in`
      let params = { ...props.params }

      if (target.value === '') {
        delete params[param]
      } else {
        params[param] = target.value
      }

      props.updateParams(params)
    }
  }

  return (
    <FormSelect
      className='[ f-c-ba-whi f-c-fo-pri f-c-bo-neu025 ] has-border'
      name={props.filter.name}
      defaultText={props.filter.default}
      options={[
        {
          value: '',
          label: '--',
          isDefault: true
        },
        ...props.filter.values.map(el => {
          return {
            value: `${el.id}`,
            label: el.name
          }
        })
      ]}
      onChange={handleSelect}
      initialValue={
        props.filter.values.find(
          el => el.id == props.filters[`${props.filter.name}__in`]
        )
          ? `${
              props.filter.values.find(
                el => el.id == props.filters[`${props.filter.name}__in`]
              ).id
            }`
          : null
      }
    />
  )
}

export default FilterSelect
